import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="visit"
export default class extends Controller {
  static values = {
    href: String
  }

  visit(event) {
    if (event.target.closest("button, a")) {
      event.stopPropagation()
      return
    }

    Turbo.visit(this.hrefValue)
  }
}
